<div class="row page-title">
  <span>{{ localizationConstants.CONTRACT_DETAILS_PAGE_TITLE | translate }}</span>
</div>
<div
  *ngIf="contracts"
  id="main-info"
  class="c-hero bg-white u-shadow">
  <div class="row">
    <div class="c-details col">
      <div class="c-details__title">{{ contracts.contractReference }}</div>
      <table class="o-list-table o-list-table--thin o-list-table--even full-width--mobile">
        <tr class="o-list-table__item">
          <td
            scope="row"
            class="o-list-table__title">
            {{ "contract.ponumber" | translate }}
          </td>
          <td class="o-list-table__description">{{ contracts.poNumber }}</td>
        </tr>
        <tr class="o-list-table__item">
          <td
            scope="row"
            class="o-list-table__title">
            {{ "contract.startdate" | translate }}
          </td>
          <td class="o-list-table__description">
            {{ contracts.startDate | date }}
          </td>
        </tr>
        <tr class="o-list-table__item">
          <td
            scope="row"
            class="o-list-table__title">
            {{ "contract.enddate" | translate }}
          </td>
          <td class="o-list-table__description">
            {{ contracts.endDate | date }}
          </td>
        </tr>
        <tr class="o-list-table__item">
          <td
            scope="row"
            class="o-list-table__title">
            {{ "contract.status" | translate }}
          </td>
          <td class="o-list-table__description">
            {{ (contracts.isActive ? "contract.active" : "contract.notactive") | translate }}
          </td>
        </tr>
      </table>
    </div>
  </div>
</div>
<div
  *ngIf="contracts"
  id="tabs"
  class="tabs row center u-scroll--horizontal">
  <div class="container col-12 col-lg-8">
    <ul class="c-tab__group">
      <li
        id="tab-info"
        class="c-tab__item"
        [routerLink]="[routeNameConstants.CONTRACTS_DETAILS_CHILD_INFO]"
        [routerLinkActive]="['active']">
        {{ "contract.statustab" | translate }}
      </li>
      <li
        id="tab-tools"
        class="c-tab__item"
        [routerLink]="[routeNameConstants.CONTRACTS_DETAILS_CHILD_TOOLS]"
        [routerLinkActive]="['active']">
        {{ "contract.toolstab" | translate }}
      </li>
      <li
        id="tab-items"
        class="c-tab__item"
        [routerLink]="[routeNameConstants.CONTRACTS_DETAILS_CHILD_ITEMS]"
        [routerLinkActive]="['active']">
        {{ "contract.itemstab" | translate }}
      </li>
      <li
        id="tab-documents"
        class="c-tab__item"
        [routerLink]="[routeNameConstants.CONTRACTS_DETAILS_CHILD_DOCUMENTS]"
        [routerLinkActive]="['active']">
        {{ "contract.documentstab" | translate }}
      </li>
    </ul>
  </div>
</div>
<div
  *ngIf="contracts"
  id="details"
  class="row u-mb-2">
  <div class="col-12">
    <router-outlet></router-outlet>
  </div>
</div>
